import { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

function Service() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/data.json")
      .then((res) => res.json())
      .then((data) => {
        setServices(data?.services_data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="bg-black text-white min-h-screen flex flex-col">
      <Header />

      <main className="flex-1">
        {/* HERO */}
        <section className="py-24 text-center bg-gradient-to-b from-black via-gray-900 to-black">
          <div className="max-w-3xl mx-auto px-6">
            <span className="text-lime-400 uppercase tracking-widest text-sm">
              Premium Motorcycle Solutions
            </span>

            <h1 className="text-4xl md:text-6xl font-bold mt-4 leading-tight">
              Our <span className="text-lime-400">Services</span>
            </h1>

            <p className="text-gray-400 mt-6 text-lg">
              We deliver high-performance motorcycle cable systems, custom
              setups, and tuning solutions designed for safety, durability, and
              precision.
            </p>
          </div>
        </section>

        {/* INTRO */}
        <section className="max-w-7xl mx-auto px-6 py-16 grid lg:grid-cols-2 gap-12 items-center">
          <img
            src="https://superstrengthcables.in/wp-content/uploads/2020/11/custom-bike-builder-motorcycle.png"
            className="rounded-2xl shadow-2xl hover:scale-105 transition duration-500"
            alt="Motorcycle customization"
          />

          <div>
            <h2 className="text-3xl font-bold text-lime-400 mb-6">
              Precision Engineering for Every Ride
            </h2>

            <p className="text-gray-400 leading-relaxed">
              We specialize in delivering high-quality motorcycle cable systems
              and performance solutions. Every product is designed with
              precision engineering to ensure smooth control, maximum
              durability, and rider safety.
            </p>

            <ul className="mt-6 space-y-3 text-gray-300">
              <li>✓ Advanced cable technology</li>
              <li>✓ Long-lasting performance materials</li>
              <li>✓ Perfect fit for all major bikes</li>
              <li>✓ Trusted by riders & workshops</li>
            </ul>

            <a
              href="/contact"
              className="inline-block mt-8 bg-lime-400 text-black px-6 py-3 rounded-xl font-semibold hover:bg-white transition"
            >
              Get Consultation
            </a>
          </div>
        </section>

        {/* SERVICES */}
        <section className="max-w-7xl mx-auto px-6 pb-20" id="services">
          <h2 className="text-center text-4xl font-bold mb-12">
            What We <span className="text-lime-400">Offer</span>
          </h2>

          {/* Loading / Empty State */}
          {loading ? (
            <p className="text-center text-gray-400">Loading services...</p>
          ) : services.length === 0 ? (
            <p className="text-center text-gray-400">
              No services available at the moment.
            </p>
          ) : (
            <div className="grid md:grid-cols-2 gap-10">
              {services.map((service) => (
                <div
                  key={service.id || service.title}
                  className="bg-gray-900 rounded-2xl overflow-hidden shadow-lg hover:shadow-lime-400/20 transition duration-500 hover:-translate-y-2"
                >
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-64 object-cover"
                  />

                  <div className="p-6">
                    <h3 className="text-2xl font-bold text-lime-400">
                      {service.title}
                    </h3>

                    <p className="text-gray-400 mt-3 leading-relaxed">
                      {service.description}
                    </p>

                    <ul className="mt-5 space-y-2 text-gray-300 text-sm">
                      {service.features?.map((feature, i) => (
                        <li key={i}>✔ {feature}</li>
                      ))}
                    </ul>

                    <a
                      href="/contact"
                      className="inline-block mt-6 bg-lime-400 text-black px-5 py-2 rounded-lg font-semibold hover:bg-white transition"
                    >
                      Get Quote
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Service;
